import React from 'react'
import {Button} from 'reactstrap'
import {AiSparkleIcon, EraserIcon, RestoreBrushIcon, RevertIcon} from '../../../../../common/icons'

function RemoveBgSidebar({
    onClose,
    onAutoRemove,
    onApply,
    applyDisabled,
    loading,
    ready,
    mode,
    brushSize,
    onSetMode,
    onSetBrushSize,
    onRevertAll,
    canUndo = false,
}) {
    return (
        <div className="RemoveBgEditor__Sidebar">
            <div className="RemoveBgEditor__SidebarContent">
                {/* Header */}
                <div className="RemoveBgEditor__SidebarHeader">
                    <h3 className="RemoveBgEditor__SidebarTitle">Remove background</h3>
                    <button
                        type="button"
                        className="RemoveBgEditor__CloseBtn"
                        onClick={onClose}
                        aria-label="Close"
                        title="Close (Esc)"
                    >
                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18 6L6 18M6 6L18 18"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                {/* Auto remove button */}
                <Button
                    className="RemoveBgEditor__AutoRemoveBtn"
                    color="light"
                    outline
                    onClick={onAutoRemove}
                    disabled={loading}
                >
                    <AiSparkleIcon width={24} height={24} />
                    <span>Auto remove</span>
                </Button>

                {/* Advanced remover section */}
                <div className="RemoveBgEditor__Section">
                    <div className="RemoveBgEditor__AdvancedHeader">
                        <p className="RemoveBgEditor__SectionTitle">Advanced remover</p>
                        <p className="RemoveBgEditor__SectionSubtitle">Customize brush parameters</p>
                    </div>

                    {/* Select mode */}
                    <div className="RemoveBgEditor__ModeSection">
                        <p className="RemoveBgEditor__ModeLabel">Select mode</p>
                        <div className="RemoveBgEditor__ModeToggle">
                            <button
                                type="button"
                                className={`RemoveBgEditor__ModeBtn ${mode === 'erase' ? 'RemoveBgEditor__ModeBtn--active' : ''}`}
                                onClick={() => onSetMode?.('erase')}
                                disabled={!ready}
                            >
                                <span className="RemoveBgEditor__ModeBtnIcon">
                                    <EraserIcon width={32} height={32} />
                                </span>
                                <span className="RemoveBgEditor__ModeBtnLabel">Erase</span>
                            </button>
                            <button
                                type="button"
                                className={`RemoveBgEditor__ModeBtn ${mode === 'restore' ? 'RemoveBgEditor__ModeBtn--active' : ''}`}
                                onClick={() => onSetMode?.('restore')}
                                disabled={!ready}
                            >
                                <span className="RemoveBgEditor__ModeBtnIcon">
                                    <RestoreBrushIcon
                                        width={32}
                                        height={32}
                                        showBadge={mode === 'restore'}
                                    />
                                </span>
                                <span className="RemoveBgEditor__ModeBtnLabel">Restore</span>
                            </button>
                        </div>
                    </div>

                    {/* Brush size */}
                    <div className="RemoveBgEditor__BrushSection">
                        <div className="RemoveBgEditor__BrushRow">
                            <span className="RemoveBgEditor__BrushLabel">Brush size</span>
                            <div className="RemoveBgEditor__BrushInput">
                                <span>{brushSize} px</span>
                            </div>
                        </div>
                        <input
                            type="range"
                            className="RemoveBgEditor__BrushSlider"
                            min={1}
                            max={200}
                            value={brushSize}
                            onChange={(e) => onSetBrushSize?.(Number(e.target.value))}
                            disabled={!ready}
                        />
                    </div>
                </div>

                {/* Revert all changes */}
                <div className="RemoveBgEditor__RevertRow">
                    <span className="RemoveBgEditor__RevertLabel">Revert all changes</span>
                    <button
                        type="button"
                        className="RemoveBgEditor__RevertBtn"
                        disabled={!ready || !canUndo}
                        onClick={onRevertAll}
                        title="Revert all changes"
                    >
                        <RevertIcon width={20} height={20} />
                    </button>
                </div>
            </div>

            {/* Apply button */}
            <Button
                className="RemoveBgEditor__ApplyBtn"
                color="primary"
                disabled={applyDisabled || !canUndo}
                onClick={onApply}
                title="Apply (Enter)"
            >
                Apply
            </Button>
        </div>
    )
}

export default RemoveBgSidebar
